"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.string.pad-start");
var _memberDay = require("@/api/activity/memberDay");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _ActivityQrcodeDialog = _interopRequireDefault(require("@/components/ActivityQrcodeDialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberDayTablePane',
  components: {
    Pagination: _Pagination.default,
    ActivityQrcodeDialog: _ActivityQrcodeDialog.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    formatDate: function formatDate(time) {
      if (!time) return '';
      var date = new Date(time);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    formatWeeks: function formatWeeks(weeks) {
      if (!weeks) return '不限';
      var names = {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '日'
      };
      var arr = String(weeks).split(',');
      if (arr.length === 7) return '每天';
      return '周' + arr.map(function (w) {
        return names[w.trim()] || w;
      }).join('、');
    }
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      qrcodeDialogVisible: false,
      qrItems: [],
      qrTitle: '',
      listQuery: {
        page: 1,
        limit: 20,
        title: ''
      }
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      this.listLoading = true;
      (0, _memberDay.getMemberDayActivityList)(this.listQuery).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function (error) {
        console.error('获取会员日活动列表失败:', error);
        _this.listLoading = false;
        _this.list = [];
        _this.total = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    handlePagination: function handlePagination() {
      this.fetchData();
    },
    handleCreate: function handleCreate() {
      this.$emit('toMemberDayConfig', null);
    },
    handleUpdate: function handleUpdate(row) {
      this.$emit('toMemberDayConfig', row.id);
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u4F1A\u5458\u65E5\u6D3B\u52A8\u300C".concat(row.title, "\u300D\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\uFF01"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberDay.deleteMemberDayActivity)(row.id);
            case 1:
              response = _context.sent;
              if (response.code === 200) {
                _this2.$message.success('删除成功');
                _this2.fetchData();
              } else {
                _this2.$message.error(response.message || '删除失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              _this2.$message.error('删除失败：' + _t.message);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }))).catch(function () {});
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this3 = this;
      (0, _memberDay.toggleMemberDayActivityStatus)(row.id, row.enabled).then(function () {
        _this3.$message.success('状态更新成功');
      }).catch(function () {
        row.enabled = row.enabled === 1 ? 0 : 1;
      });
    },
    // 复制活动：拉取详情后清空ID另存为新活动（后端保存时模块/明细ID会重置，主表ID为空即新增）
    handleCopy: function handleCopy(row) {
      var _this4 = this;
      this.$confirm("\u786E\u5B9A\u8981\u590D\u5236\u6D3B\u52A8\u300C".concat(row.title, "\u300D\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, data, res, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _memberDay.getMemberDayActivityDetail)(row.id);
            case 1:
              response = _context2.sent;
              data = response && response.data || response;
              if (data) {
                _context2.next = 2;
                break;
              }
              _this4.$message.error('复制失败：获取活动详情失败');
              return _context2.abrupt("return");
            case 2:
              data.id = null;
              data.title = (data.title || '') + '(副本)';
              if (data.modules) {
                data.modules.forEach(function (m) {
                  m.id = null;
                  if (m.items) {
                    m.items.forEach(function (it) {
                      it.id = null;
                    });
                  }
                });
              }
              _context2.next = 3;
              return (0, _memberDay.saveMemberDayActivity)(data);
            case 3:
              res = _context2.sent;
              if (res.code === 200) {
                _this4.$message.success('复制成功');
                _this4.fetchData();
              } else {
                _this4.$message.error(res.message || '复制失败');
              }
              _context2.next = 5;
              break;
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](0);
              _this4.$message.error('复制失败：' + (_t2.message || _t2));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 4]]);
      }))).catch(function () {});
    },
    // 生成活动页二维码（会员日活动仅在社区端展示）
    handleQrcode: function handleQrcode(row) {
      if (!row || !row.id) {
        this.$message.warning('无法生成二维码：数据异常');
        return;
      }
      this.qrItems = [{
        label: '社区端',
        url: "".concat(process.env.VUE_APP_COMMUNITY_URL, "/memberDay/").concat(row.id)
      }];
      this.qrTitle = row.title || '会员日活动';
      this.qrcodeDialogVisible = true;
    }
  }
};